const data = {
  adSense: {
    client: 'ca-pub-8682163816564781',
    slot: '1760408779',
  },
  navs: [
    {name: 'Home', slug: '', icon: 'home'},
    {name: 'Colors', icon: 'alert', list: []},
    {name: 'Random', slug: 'random', icon: 'experiment'},
    {name: 'Info', icon: 'info-circle', list: [
      {name: 'Privacy Policy', slug: 'privacy', icon: ''},
      {name: 'Terms of Service', slug: 'terms', icon: ''},
      {name: 'About', slug: 'about', icon: ''},
    ]},
  ],
  colors: [
    {
      name: 'Red',
      list: [
        {name: 'Wax Flower', value: '#f1a9a0'},
        {name: 'Vivid Tangerine', value: '#ff9478'},
        {name: 'New York Pink', value: '#e08283'},
        {name: 'Sunglo', value: '#e26a6a'},
        {name: 'Soft Red', value: '#ec644b'},
        {name: 'Chestnut Rose', value: '#d24d57'},
        {name: 'Valencia', value: '#d64541'},
        {name: 'Cabaret', value: '#d2527f'},
        {name: 'Razzmatazz', value: '#db0a5b'},
        {name: 'Radical Red', value: '#f62459'},
        {name: 'Sunset Orange', value: '#f64747'},
        {name: 'Pomegranate', value: '#f03434'},
        {name: 'Scarlet', value: '#f22613'},
        {name: 'Cinnabar', value: '#e74c3c'},
        {name: 'Thunderbird', value: '#d91e18'},
        {name: 'Monza', value: '#cf000f'},
        {name: 'Tall Poppy', value: '#c0392b'},
        {name: 'Old Brick', value: '#96281b'},
      ],
    },
    {
      name: 'Purple',
      list: [
        {name: 'Blue Chalk', value: '#f1e7fe'},
        {name: 'Wistful', value: '#aea8d3'},
        {name: 'Scampi', value: '#736598'},
        {name: 'Mauve', value: '#d5b8ff'},
        {name: 'Light State Blue', value: '#9f5afd'},
        {name: 'Electric Indigo', value: '#8c14fc'},
        {name: 'Electric Purple', value: '#a537fd'},
        {name: 'Medium Purple', value: '#bf55ec'},
        {name: 'Snuff', value: '#dcc6e0'},
        {name: 'Lavender Purple', value: '#947cb0'},
        {name: 'Light Wisteria', value: '#be90d4'},
        {name: 'Ce Soir', value: '#a96dad'},
        {name: 'Wisteria', value: '#9b59b6'},
        {name: 'Studio', value: '#8e44ad'},
        {name: 'Seance', value: '#9a12b3'},
        {name: 'Plum', value: '#913d88'},
        {name: 'Medium Red Violet', value: '#963694'},
        {name: 'Rebecca Purple', value: '#663399'},
        {name: 'Honey Flower', value: '#674172'},
      ],
    },
    {
      name: 'Blue',
      list: [
        {name: 'Alice Blue', value: '#e4f1fe'},
        {name: 'Humming Bird', value: '#c5eff7'},
        {name: 'Spray', value: '#81cfe0'},
        {name: 'Iris Blue', value: '#00b5cc'},
        {name: 'Shakespeare', value: '#52b3d9'},
        {name: 'Ming', value: '#336e7b'},
        {name: 'Sherpa Blue', value: '#013243'},
        {name: 'Pickled Bluewood', value: '#34495e'},
        {name: 'Madison', value: '#2c3e50'},
        {name: 'Ebony Clay', value: '#22313f'},
        {name: 'Shark', value: '#24252a'},
        {name: 'Jordy Blue', value: '#89c4f4'},
        {name: 'Malibu', value: '#6bb9f0'},
        {name: 'Picton Blue', value: '#59abe3'},
        {name: 'Deep Sky Blue', value: '#19b5fe'},
        {name: 'Dodger Blue', value: '#22a7f0'},
        {name: 'Curious Blue', value: '#3498db'},
        {name: 'Mariner', value: '#2c82c9'},
        {name: 'Fountain Blue', value: '#5c97bf'},
        {name: 'Summer Sky', value: '#1e8bc3'},
        {name: 'Jelly Bean', value: '#2574a9'},
        {name: 'Havelock Blue', value: '#4183d7'},
        {name: 'Air Force Blue', value: '#4b77be'},
        {name: 'San Marino', value: '#446cb3'},
        {name: 'Chambray', value: '#3a539b'},
        {name: 'Jacksons Purple', value: '#1f3a93'},
        {name: 'Han Purple', value: '#4d05e8'},
        {name: 'Royal Blue', value: '#5333ed'},
        {name: 'Persian Blue', value: '#4d13d1'},
      ],
    },
    {
      name: 'Green',
      list: [
        {name: 'Madang', value: '#c8f7c5'},
        {name: 'Riptide', value: '#86e2d5'},
        {name: 'Aqua Island', value: '#a2ded0'},
        {name: 'Light Green', value: '#7befb2'},
        {name: 'Medium Turquiose', value: '#4ecdc4'},
        {name: 'Emerald', value: '#3fc380'},
        {name: 'Ocean Green', value: '#4daf7c'},
        {name: 'Shamrock', value: '#2ecc71'},
        {name: 'Medium Aquamarine', value: '#66cc99'},
        {name: 'Silver Tree', value: '#68c3a3'},
        {name: 'Jungle Green', value: '#26c281'},
        {name: 'Turquiose', value: '#36d7b7'},
        {name: 'Bright Turquiose', value: '#29f1c3'},
        {name: 'Caribbean Green', value: '#03c9a9'},
        {name: 'Java', value: '#23cba7'},
        {name: 'Niagara', value: '#2abb9b'},
        {name: 'Mountain Meadow', value: '#16a085'},
        {name: 'Observatory', value: '#049372'},
        {name: 'Green Haze', value: '#019875'},
        {name: 'Free Speech Aquamarine', value: '#03a678'},
        {name: 'Salem', value: '#1e824c'},
        {name: 'Downy', value: '#65c6bb'},
        {name: 'Light Sea Green', value: '#1ba39c'},
        {name: 'Jade', value: '#00b16a'},
        {name: 'Eucalyptus', value: '#26a65b'},
        {name: 'Gossip', value: '#87d37c'},
        {name: 'Dark Sea Green', value: '#90c695'},
        {name: 'Summer Green', value: '#91b496'},
        {name: 'Malachite', value: '#00e640'},
      ],
    },
    {
      name: 'Yellow',
      list: [
        {name: 'Orchid White', value: '#f0f0d6'},
        {name: 'Gin Fizz', value: '#fff9de'},
        {name: 'Cream', value: '#ffffcc'},
        {name: 'Dolly', value: '#ffff7e'},
        {name: 'Marigold Yellow', value: '#f4f776'},
        {name: 'Witch Haze', value: '#fff68f'},
        {name: 'Salomie', value: '#ffec8b'},
        {name: 'Candy Corn', value: '#fef160'},
        {name: 'Energy Yello', value: '#f5e653'},
        {name: 'Turbo', value: '#f5e51b'},
        {name: 'Chartreuse Yellow', value: '#eeee00'},
        {name: 'Yellow', value: '#f0ff00'},
        {name: 'Buff', value: '#f2d984'},
        {name: 'Cream Can', value: '#f5d76e'},
        {name: 'Confetti', value: '#e9d460'},
        {name: 'Kournikova', value: '#fad859'},
        {name: 'Saffron', value: '#f4d03f'},
        {name: 'Ripe Lemon', value: '#f7ca18'},
      ],
    },
    {
      name: 'Orange',
      list: [
        {name: 'Vivid', value: '#f15a22'},
        {name: 'Cape Honey', value: '#fde3a7'},
        {name: 'Goldenrod', value: '#fcd670'},
        {name: 'My Sin', value: '#fcb941'},
        {name: 'Sandstorm', value: '#f9bf3b'},
        {name: 'Saffron Mango', value: '#fabe58'},
        {name: 'Casablanca', value: '#f4b350'},
        {name: 'Lightning Yellow', value: '#f5ab35'},
        {name: 'Supernova', value: '#ffcb05'},
        {name: 'Sea Buckthorn', value: '#f9b42d'},
        {name: 'Buttercup', value: '#f39c12'},
        {name: 'Fire Bush', value: '#eb9532'},
        {name: 'California', value: '#f89406'},
        {name: 'Sea Buckthorn II', value: '#eb974e'},
        {name: 'Carrot Orange', value: '#e67e22'},
        {name: 'Tahiti Gold', value: '#e87e04'},
        {name: 'Zest', value: '#e47833'},
        {name: 'Jaffa', value: '#f27935'},
        {name: 'Ecstasy', value: '#f9690e'},
        {name: 'Crusta', value: '#f2784b'},
        {name: 'Burnt Orange', value: '#d35400'},
      ],
    },
    {
      name: 'Grey',
      list: [
        {name: 'Mystic', value: '#e8ecf1'},
        {name: 'Gallery', value: '#eeeeee'},
        {name: 'Cararra', value: '#f2f1ef'},
        {name: 'White Smoke', value: '#ececec'},
        {name: 'Mercury', value: '#e8e8e8'},
        {name: 'Pampas', value: '#f3f1ef'},
        {name: 'Porcelain', value: '#ecf0f1'},
        {name: 'Solitude', value: '#e4e9ed'},
        {name: 'Iron', value: '#dadfe1'},
        {name: 'Silver Sand', value: '#bdc3c7'},
        {name: 'Pumice', value: '#d2d7d3'},
        {name: 'Edward', value: '#abb7b7'},
        {name: 'Cascade', value: '#95a5a6'},
        {name: 'Silver', value: '#bfbfbf'},
        {name: 'Lynch', value: '#6c7a89'},
        {name: 'Hoki', value: '#67809f'},
        {name: 'Outer Space', value: '#2e3131'},
      ],
    },
  ]
}

// add slug property from name for each color group
data.colors.forEach((e,i)=>{
  const {name} = e
  const slug = name.toLowerCase()
  data.colors[i].slug = slug
  data.navs[1].list.push({name,slug})
})
export default data
